export default __webpack_public_path__ + "static/media/loading.84f8b8b0.gif";